const map = {
    //hive
    hiveio: 'hive',
};

export default map;
